const scrollPos = () => window.pageYOffset;

const lock = (stickyElements = '') => {
  const body = document.querySelector('body');
  const pos = scrollPos();

  if (stickyElements) {
    const sticky = document.querySelectorAll(stickyElements);
    if (sticky.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < sticky.length; i++) {
        sticky[i].style.position = 'relative';
        sticky[i].style.top = `${pos}px`;
      }
    }
  }

  body.style.position = 'fixed';
  body.style.top = `-${pos}px`;
};

const unlock = (stickyElements = '') => {
  const body = document.querySelector('body');
  let pos = body.style.top;
  pos = parseFloat(pos) * -1;

  body.style.position = '';
  body.style.top = '';

  if (stickyElements) {
    const sticky = document.querySelectorAll(stickyElements);
    if (sticky.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < sticky.length; i++) {
        sticky[i].style.position = '';
        sticky[i].style.top = '';
      }
    }
  }

  window.scrollBy(0, pos);
};

const islocked = () => {
  const body = document.querySelector('body');
  if (
    window
      .getComputedStyle(body)
      .getPropertyValue('position')
      .toLowerCase() === 'fixed'
  ) {
    return true;
  }
  return false;
};

export default { lock, unlock, islocked };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/scrollLock.js